export default __webpack_public_path__ + "static/media/spinner.e2ffacc9.gif";